import React, { useEffect, useState } from "react";
import { Link, useHistory, useParams } from "react-router-dom";
import jwt from "jwt-decode";
import { acceptInvite, inviteOtp, publicInvite } from "../../services/partnerNetworkApi";
import { clearStudioWorkspaceCaches } from "../../helpers/studioSignupSession";
import "./partner-link.scss";

/** Store a fresh studio session the same way Login does. */
export const startStudioSession = (tokens: { token: string; refreshToken: string }) => {
  const authUser: any = jwt(tokens.token);
  localStorage.setItem("authUser", JSON.stringify(authUser));
  localStorage.setItem("token", tokens.token);
  localStorage.setItem("refreshToken", tokens.refreshToken);
  clearStudioWorkspaceCaches();
};

/** Invite from a designer. SPONSORED: phone OTP creates the partner's own workspace. HKP_EXISTING: sign in. */
const PartnerInvitePage = () => {
  const { token } = useParams<{ token: string }>();
  const history = useHistory();
  const [invite, setInvite] = useState<any>(null);
  const [error, setError] = useState("");
  const [sent, setSent] = useState(false);
  const [otp, setOtp] = useState("");
  const [orgName, setOrgName] = useState("");
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    publicInvite(token).then((res) => {
      if (res.success) {
        setInvite(res.data);
        setOrgName(res.data?.invitedName || "");
      } else {
        setError(res.message || "This invite link doesn't work.");
      }
    });
  }, [token]);

  if (error) {
    return (
      <main className="plink plink--center">
        <div className="plink__brand">HKP</div>
        <p className="plink__error">{error}</p>
      </main>
    );
  }
  if (!invite) {
    return (
      <main className="plink plink--center" aria-busy="true">
        <div className="plink__skeleton" />
      </main>
    );
  }

  return (
    <main className="plink">
      <header className="plink__top">
        <div className="plink__brand">HKP</div>
      </header>
      <section className="plink__card">
        <p className="plink__eyebrow">Invitation</p>
        <h1 className="plink__title">{invite.designer} wants to send you production orders</h1>
        <p className="plink__spec">
          Your workspace stays yours. Workers, wages, costs and other clients stay private; you choose what{" "}
          {invite.designer} sees on each order. Receiving orders is free.
        </p>
      </section>
      {invite.signInToAccept ? (
        <Link className="plink__btn plink__btn--primary plink__linkbtn" to="/login">
          Sign in to accept
        </Link>
      ) : (
        <section className="plink__card plink__form">
          <label>
            Studio or cooperative name
            <input value={orgName} onChange={(e) => setOrgName(e.target.value)} />
          </label>
          <label>
            Your name
            <input value={name} onChange={(e) => setName(e.target.value)} />
          </label>
          {sent ? (
            <label>
              Code sent to {invite.phoneHint}
              <input inputMode="numeric" autoComplete="one-time-code" maxLength={4} value={otp}
                onChange={(e) => setOtp(e.target.value.replace(/\D/g, ""))} />
            </label>
          ) : null}
          {sent ? (
            <button className="plink__btn plink__btn--primary" disabled={busy || otp.length !== 4}
              onClick={async () => {
                setBusy(true);
                const res = await acceptInvite(token, { otp, orgName, name });
                setBusy(false);
                if (res.success && res.data?.tokens?.token) {
                  startStudioSession(res.data.tokens);
                  history.replace("/partner-network/incoming");
                } else {
                  setError(res.message || "Could not accept the invite.");
                }
              }}>
              Accept and open my workspace
            </button>
          ) : (
            <button className="plink__btn plink__btn--primary" disabled={busy}
              onClick={async () => {
                setBusy(true);
                const res = await inviteOtp(token);
                setBusy(false);
                if (res.success) setSent(true);
                else setError(res.message || "Could not send the code.");
              }}>
              Send code to {invite.phoneHint}
            </button>
          )}
        </section>
      )}
    </main>
  );
};

export default PartnerInvitePage;
